var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.8377 49.9316C99.8377 77.3629 77.6002 99.6004 50.1689 99.6004C22.7375 99.6004 0.5 77.3629 0.5 49.9316C0.5 22.5002 22.7375 0.262695 50.1689 0.262695C77.6002 0.262695 99.8377 22.5002 99.8377 49.9316Z",
    fill: "#FFF9DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3494 25.7595L59.2793 33.5799L49.3721 33.266L49.2776 33.2624L49.2293 33.3442L41.5391 46.3217L41.5243 46.3468L41.519 46.3753L38.9741 60.687L30.3648 62.3552L25.3573 31.0342L58.3494 25.7595Z",
    fill: "#88A546",
    stroke: "#5D0020",
    strokeWidth: 0.320444
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3928 35.3826L27.0376 33.1624L28.1605 32.2094L34.0934 31.0809L38.7354 56.5646L36.8128 57.0453L38.0945 60.4099L30.8553 62.4969L26.3928 35.3826Z",
    fill: "#ECFCB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0103 73.1545L33.5546 72.3378L32.4957 70.9814L31.2151 63.9036L59.333 58.9634L59.8749 61.2597L63.5835 59.8124L65.93 68.4648L36.0103 73.1545Z",
    fill: "#204232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3809 69.4938L24.5433 36.3903C24.2852 34.927 24.619 33.4212 25.4712 32.204C26.3235 30.9869 27.6243 30.1581 29.0876 29.9001L56.6738 25.0354C57.2591 24.9322 57.8615 25.0657 58.3483 25.4066C58.8352 25.7475 59.1667 26.2678 59.2699 26.8531L60.8332 34.6217M30.3809 69.4938C30.6389 70.9571 31.4677 72.2579 32.6848 73.1101C33.902 73.9624 35.4078 74.2962 36.8711 74.0381L64.4573 69.1734C65.0426 69.0702 65.563 68.7387 65.9039 68.2518C66.2448 67.765 66.3783 67.1627 66.2751 66.5773L65.4797 61.8595M30.3809 69.4938C30.1228 68.0305 30.4567 66.5247 31.3089 65.3076C32.1611 64.0904 33.4619 63.2617 34.9252 63.0036L42.8883 61.539",
    stroke: "#326838",
    strokeWidth: 4.29395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3086 27.6953L37.7281 26.205L40.5011 41.8709L35.6236 39.0391L32.0816 43.3612L29.3086 27.6953Z",
    fill: "#DE3268"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4531 27.4825L36.7078 26.3754L38.9661 39.1334L35.2974 36.7735L32.7114 40.2405L30.4531 27.4825Z",
    fill: "#FE4A65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6484 33.9824L83.3448 43.9257L76.5007 69.1843L70.3551 68.0343L65.3882 60.6641L53.2113 57.2994L47.7637 60.6641L39.8043 59.2411L46.6484 33.9824Z",
    fill: "#00A08B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6504 41.3848L81.0899 44.4823L81.0899 59.5432L76.7582 66.9907L74.6504 41.3848Z",
    fill: "#B1FBE1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0019 46.1893L54.0563 47.3138L58.1107 48.4383M55.1694 43.3005L52.9432 51.3271M67.6902 53.2563L67.7105 53.2619M74.8849 50.9298L74.9052 50.9354M76.2892 40.5142L54.7197 34.5318C52.7132 33.9757 50.574 34.1758 48.7154 35.0933C46.8569 36.0107 45.4111 37.5804 44.6575 39.499L44.5384 39.7944C43.9991 41.1013 39.9696 50.8752 39.1103 53.9735C38.6675 55.5701 38.8835 57.279 39.7109 58.7243C40.5383 60.1696 41.9093 61.2329 43.5222 61.6802C45.5494 62.2425 46.8413 61.5203 48.1332 60.7981L51.7866 58.7557C52.7556 58.2139 53.904 58.0769 54.9793 58.3749L63.7854 60.8173C64.8606 61.1158 65.7743 61.8247 66.3258 62.7882L68.4052 66.4207C69.1406 67.7051 69.8759 68.9896 71.9031 69.5518C73.516 69.9992 75.2388 69.794 76.6925 68.9814C78.1461 68.1687 79.2116 66.8153 79.6544 65.2187C80.5143 62.1184 82.0943 51.6673 82.3052 50.2693C82.3195 50.1652 82.3361 50.061 82.3548 49.9567C82.6977 47.9239 82.2673 45.8333 81.1469 44.0892C80.0265 42.345 78.2957 41.0713 76.2892 40.5142Z",
    stroke: "#174655",
    strokeWidth: 4.57778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar10);
export default __webpack_public_path__ + "static/media/avatar10.0266284054d696fda0a4c5ee9271a34f.svg";
export { ForwardRef as ReactComponent };